export const isValidPassword = (password) => {
  const commonPasswords = ['password', '123456', 'admin'];
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,50}$/;

  if (!password || password.trim() === '') {
    return { valid: false, message: "Password is required." };
  }

  if (password.length > 60) {
    return { valid: false, message: "Password must not exceed 60 characters." };
  }

  if (password.length < 8) {
    return { valid: false, message: "Password doesn't meet the required criteria." };
  }

  if (!regex.test(password)) {
    return {
      valid: false,
      message:
        "Password doesn't meet the required criteria."
    };
  }

  if (/(.)\1{2,}/.test(password)) {
    return { valid: false, message: "Password must not have repeated characters like 'aaa' or '111'." };
  }

  const lowerPassword = password.toLowerCase();
  if (commonPasswords.some(p => lowerPassword.includes(p))) {
    return { valid: false, message: "Password must not include common words like 'password', '123456', or 'admin'." };
  }

  return { valid: true, message: "" };
};
